import { type FC, useState } from 'react';
import { PlantNavigation } from '@components/Plant/PlantNavigation/PlantNavigation';
import { PlantBurger } from '@components/ui/PlantBurger/PlantBurger';

import { PlantNavigationItem } from '@/components/Plant/PlantNavigation/PlantNavigationItem/PlantNavigationItem';
import { selectShortWorkshopInfo } from '@/redux/selectors/workshopSelectors';
import { useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

const WorkshopNavigation: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const workshopList = useAppSelector(selectShortWorkshopInfo);

  const onClose = (): void => {
    setIsOpen(false);
  };

  return (
    <>
      <PlantBurger
        onClick={() => setIsOpen(true)}
        className="relative z-[1] cursor-pointer pointer-events-auto"
      />
      <PlantNavigation
        list={workshopList}
        item={(props) => (
          <PlantNavigationItem key={props.id} {...props} onClose={onClose} />
        )}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className={css.navPaddingTop}
      />
    </>
  );
};

export { WorkshopNavigation };
